<!-- 文章发布列表页 -->
<template>
  <div>
    <el-card class="box-card set-card" style="position: relative">
      <div class="box-top">
        <el-button class="sendNewsBtn" @click="toParticulars(false)">发布文章</el-button>
        <el-cascader :options="options" :props="{ value: 'id', label: 'name', checkStrictly: true }" clearable
          placeholder="全部" :show-all-levels="false" @change="handlechange"></el-cascader>
      </div>
      <div class="text item">
        <el-table style="width: 100%" :data="articleData" class="table-content">
          <el-table-column align="center" show-overflow-tooltip width="100" label="编号" :fit="true" type="index">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip width="300" label="标题" prop="title"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip width="150" label="所属列表" prop="nowTypeName">
            <template slot-scope="scope">
              <div class='ellipsis' slot="reference">{{ scope.row.nowTypeName }}-{{ scope.row.typeName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label='发布时间' prop="createTime"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip width="100" label="状态" prop="title">
            <template slot-scope="scope">
              <div class='ellipsis' v-if="scope.row.status==1" slot="reference">
                <el-tag size="medium" type="success">已发布</el-tag>
              </div>
              <div class='ellipsis' v-if="scope.row.status==2" slot="reference">
                <el-tag size="medium" type="info">未发布</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <!--              <el-button size="mini" @click="toParticulars(false,scope.row)" class="table-compile">详情</el-button>-->
              <el-button type="primary" @click="toParticulars(false,scope.row)" class="table-compile">编辑</el-button>
              <!-- <el-button v-if="scope.row.status==1" type="success" @click="updateArticle(scope.row,2)"
                class="table-compile">下架</el-button> -->
              <el-button v-if="scope.row.status==2" type="success" @click="updateArticle(scope.row,1)"
                class="table-compile">发布</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagelist" style="text-align: center">
        <el-row type="flex" justify="center">
          <el-col :span="24" class="nomore" style="margin-top:24px;">
            <!-- <span v-if="isShow">没有更多了</span> -->
            <el-pagination class="page" background :current-page="currentPage" @current-change="current_page"
              layout="total, prev, pager, next, jumper" :total="dataNumber">
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <!-- 分页-->
    <!--		<el-row type="flex" justify="center">-->
    <!--			<el-col :span="24" class="nomore" style="margin-top: 24px">-->
    <!--				&lt;!&ndash; <span v-if="isShow">没有更多了</span> &ndash;&gt;-->
    <!--				<el-pagination-->
    <!--					class="page"-->
    <!--					background-->
    <!--					:current-page="currentPage"-->
    <!--					@current-change="current_page"-->
    <!--					layout="total, prev, pager, next, jumper"-->
    <!--					:total="dataNumber"-->
    <!--				>-->
    <!--				</el-pagination>-->
    <!--			</el-col>-->
    <!--		</el-row>-->
    <!-- end -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      size: "10",
      type: "", // 1新闻通告    0求职须知
      dataNumber: 0, // 有多少条数据
      currentPage: 1,
      typeData: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "求职须知",
        },
        {
          value: "1",
          label: "新闻通告",
        },
      ],
      articleData: [],
      options: [],
      tyidThree: "",
      Typeid: "",
    };
  },
  methods: {
    updateArticle(row, status) {
      let userInfoId = JSON.parse(sessionStorage.getItem("userInfo")).id;
      this.axiosPost("/newsNotice/update", {
        id: row.id, // 文章id
        updateEmp: userInfoId, // 管理员id
        status: status, //文章状态(0删除，1发布，2未发布)
      }).then((res) => {
        if (res.code == 200) {
          this.getAricleFn()
          this.$message({
            showClose: true,
            message: res.message,
            type: "success",
            duration: "1800",
          });
          this.$router.push({
            path: '/articleHome',
            replace: true
          })
          that.$emit("statusFun", true);
        }
      });
    },
    // 小程序新闻树
    getTree() {
      this.axiosGet(`/common/findSysDictByNewsNoticeTree?code=${"journalism_menu"}`).then((res) => {
        if (res.code == 200) {
          this.options = res.data;
        }
      });
    },
    // 选择类型
    handlechange(data) {
      var data1 = data.slice(-1);
      let grouping = data1.toString();
      this.Typeid = grouping;
      this.tyidThree = data[0];
      this.getAricleFn();
    },
    //页面跳转到文章详情
    toParticulars(status, data) {
      if (data) {
        this.$router.push({
          name: "addArticle",
          params: {
            data: data,
          },
        });
      } else {
        // publicVue.articleInfo = "";
        this.$router.push({
          name: "addArticle",
        });
      }
      // this.$emit("statusFun", status);
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage;
      this.getAricleFn();
      this.Filterarticles();
    },
    //获取文章列表
    getAricleFn() {
      this.axiosGet("/newsNotice/selectByType", {
        params: {
          type: this.Typeid,
          nowType: this.tyidThree,
          page: this.page,
          size: this.size,
          isHomePage: 0,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.articleData = res.data.list;
          this.dataNumber = res.data.total;
        }
      });
    },
  },
  filters: {
    checkVal(str) {
      let reg1 =
        /<img.*?>|<p>|<\/p>|<u>|<\/u>|<strong>|<\/strong>|<em>|<\/em>|<h1>|<\/h1>|<h2>|<\/h2>|<sub>|<\/sub>|<span.*?<\/span>|<sup>|<\/sup>|<h1.*?>|<sup.*?>/gi;
      str = str.replace(reg1, "").substring(0, 200);
      return str;
    },
  },
  created() {
    this.getAricleFn();
    this.getTree();
  },
  updated() {
  },

};
</script>
<style lang="less" scoped>
.newsList-box {
  width: 100%;

  .newsItemBox {
    transition: .2s;
    padding-left: 30px;
    display: flex;
    justify-content: space-between;

    .title-Top {
      line-height: 60px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 300px;

    }

    .BelongingContent {
      line-height: 60px;
      color: black;
    }

    .updateTime {
      line-height: 60px;
    }

    .content-bottom {
      line-height: 60px;
      margin-right: 30px;
    }
  }

  .newsItemBox:hover {
    box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
  }
}

// 分页
.box-card {
  .box-top {
    padding: 36px 32px 0 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

}

.nomore {
  line-height: 50px;
  text-align: center;
  margin-top: 24px // margin-top:10px;
}

.small-title {
  position: absolute;
  top: 0;
  right: 0;
  width: 45%;
  height: 25px;
  background: rgba(0, 0, 0, .5);
  color: #ffffff;
  font-size: 9px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 25px;
  text-align: center;
  border-bottom-left-radius: 4px;
}

.table-compile {
  padding: 8px 15px;
}
</style>
